import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { useModalsContext, useQueryContext } from '../contexts';
import { ExtendedChannel } from '../types';

export const displayContent = {
  subscribeAllMarketingChannels: 'Subscribe to all marketing channels',
  unsubscribeAllMarketingChannels: 'Unsubscribe from all marketing channels',
};

const areMostChannelsUnsubscribed = (channels: ExtendedChannel[]): boolean => {
  const half = Math.floor(channels.length / 2);
  const unsubChannels = channels.filter((channel) => !channel.isSubscribed);

  return unsubChannels.length > half;
};

export const SubscriptionsButton = () => {
  const { showModal } = useModalsContext();
  const { marketingChannels } = useQueryContext();

  const hasUnsubscribedMarketingChannels = areMostChannelsUnsubscribed(marketingChannels);

  const handleAllMarketingSubscriptions = () => {
    if (hasUnsubscribedMarketingChannels) {
      showModal({ subscribingToChannels: marketingChannels });
    } else {
      showModal({ unsubscribingFromChannels: marketingChannels });
    }
  };

  return (
    <SecondaryButton onClick={handleAllMarketingSubscriptions} size={BUTTON_SIZES.LARGE}>
      {hasUnsubscribedMarketingChannels
        ? displayContent.subscribeAllMarketingChannels
        : displayContent.unsubscribeAllMarketingChannels}
    </SecondaryButton>
  );
};
